import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import { IconButton, Stack } from '@mui/material';
import { CouponGiftDTO, CouponGiftDTOGiftTypeEnum, CouponGiftDTOStatusEnum } from 'probonio-shared-ui/api';
import React, { MouseEventHandler, useCallback } from 'react';
import { useGiftActivationModal } from '../modals/useGiftActivationModal ';

interface Props {
  gift: CouponGiftDTO;
}

export function GiftActivationActions({ gift }: Props): React.JSX.Element {
  const { onGiftEdit, onGiftDelete, onIncentiveEdit, onIncentiveDelete } = useGiftActivationModal();
  const handleStopPropagation = useCallback<MouseEventHandler>(event => {
    event.stopPropagation();
  }, []);

  const handleOpenDeleteGiftDialog = useCallback(
    (event: React.MouseEvent): void => {
      handleStopPropagation(event);
      if (gift.giftType === CouponGiftDTOGiftTypeEnum.Incentive) {
        onIncentiveDelete(gift);
      } else {
        onGiftDelete(gift);
      }
    },
    [gift, handleStopPropagation, onGiftDelete, onIncentiveDelete],
  );

  const handleOpenDialogToEdit = useCallback(
    (event: React.MouseEvent) => {
      handleStopPropagation(event);
      if (gift.giftType === CouponGiftDTOGiftTypeEnum.Incentive) {
        onIncentiveEdit(gift);
      } else {
        onGiftEdit(gift);
      }
    },
    [gift, handleStopPropagation, onGiftEdit, onIncentiveEdit],
  );

  const wasPayed = gift.status === CouponGiftDTOStatusEnum.Available || gift.status === CouponGiftDTOStatusEnum.Redeemed;
  const isPending = gift.status === CouponGiftDTOStatusEnum.Pending;
  return (
    <>
      <Stack
        direction="row"
        sx={{
          justifyContent: 'flex-end',
        }}
      >
        <IconButton
          sx={{
            display: isPending ? '' : 'none',
          }}
          onClick={handleOpenDialogToEdit}
          onMouseDown={handleStopPropagation}
        >
          <EditIcon fontSize="small" />
        </IconButton>
        <IconButton
          sx={{
            display: isPending || !wasPayed ? '' : 'none',
          }}
          onClick={handleOpenDeleteGiftDialog}
          onMouseDown={handleStopPropagation}
        >
          <DeleteIcon fontSize="small" />
        </IconButton>
      </Stack>
    </>
  );
}
